module.exports = __webpack_public_path__ + "static/media/pix.b13ab11d.png";